import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AuthGuard } from './guards/auth.guard';
import { SitePageModule } from './site/site.module';
import { SitePage } from './site/site.page';

const routes: Routes = [
  { path: '', redirectTo: 'site', pathMatch: 'full' },
  { path: 'site/:siteId/access/create', redirectTo: 'site/:siteId/access/create/type-choice', pathMatch: 'full' },
  {
    path: 'access/create',
    loadChildren: () => import('./access/create-all/type-choice/stepper/stepper.module').then(m => m.StepperPageModule)
  },
  { 
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule) 
  },
  {
    path: 'register',
    loadChildren: () => import('./auth/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'otp',
    loadChildren: () => import('./auth/otp/otp.module').then(m => m.OtpPageModule)
  },
  {
    path: 'site/:siteId/access',
    canActivate: [AuthGuard],
    loadChildren: () => import('./access/access.module').then(m => m.AccessPageModule)
  },
  {
    path: 'site/:siteId/overview',
    canActivate: [AuthGuard],
    loadChildren: () => import('./site/overview/overview.module').then(m => m.OverviewPageModule)
  },
  {
    path: 'site/:siteId/collaborator',
    canActivate: [AuthGuard],
    loadChildren: () => import('./site/collaborator/collaborator.module').then(m => m.CollaboratorPageModule)
  },
  {
    path: 'site/:siteId/event',
    canActivate: [AuthGuard],
    loadChildren: () => import('./event/event.module').then(m => m.EventPageModule)
  },
  {
    path: 'site/create',
    canActivate: [AuthGuard],
    loadChildren: () => import('./site/create/create.module').then(m => m.CreatePageModule)
  },
  {
    path: 'site/:siteId/device',
    canActivate: [AuthGuard],
    loadChildren: () => import('./device/device.module').then(m => m.DevicePageModule)
  },
  {
    path: 'site/:siteId/addCollab',
    loadChildren: () => import('./shared/modals/add-collab-modal/add-collab-modal.module').then(m => m.AddCollabModalPageModule)
  },
  {
    path: 'site/:siteId/editCollab/:userId',
    loadChildren: () => import('./shared/modals/rights-modal/rights-modal.module').then(m => m.RightsModalPageModule)
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.module').then(m => m.UserPageModule)
  },
  {
    path: 'site',
    canActivate: [AuthGuard],
    component: SitePage,
    // loadChildren: () => import('./site/site.module').then(m => m.SitePageModule)
  },
  {
    path: 'lostPassword',
    loadChildren: () => import('./auth/reset-password/send-mail/send-mail.module').then(m => m.SendMailPageModule)
  },
  {
    path: 'resetPassword/:token',
    loadChildren: () => import('./auth/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
  },
  {
    //   path: 'site/:siteId/event',
    //   loadChildren: () => import('./event/event.module').then(m => m.EventPageModule)
    // },
    path: 'site/:siteId/event',
    loadChildren: () => import('./event/event.module').then(m => m.EventPageModule)
  },
  {
    path: 'access',
    loadChildren: () => import('./access-all/access-all.module').then(m => m.AccessAllPageModule)
  },
  {
    path: 'device',
    loadChildren: () => import('./device-all/device-all.module').then(m => m.DeviceAllPageModule)
  },
  {
    path: 'task',
    loadChildren: () => import('./task/task.module').then(m => m.TaskPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./notification/notification.module').then(m => m.NotificationPageModule)
  },
  {
    path: 'organization',
    loadChildren: () => import('./organization/organization.module').then(m => m.OrganizationPageModule)
  },
  {
    path: 'store-links',
    loadChildren: () => import('./store-links/store-links.module').then(m => m.StoreLinksPageModule)
  },
  {
    path: '**',
    loadChildren: () => import('./path-not-found/path-not-found.module').then(m => m.PathNotFoundPageModule)
  }
  // {
  //   path: 'pin-code-modal',
  //   loadChildren: () => import('./shared/modals/pin-code-modal/pin-code-modal.module').then( m => m.PinCodeModalPageModule)
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: QuicklinkStrategy })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
